import { render, staticRenderFns } from "./content_edit_Case.vue?vue&type=template&id=943abbba&scoped=true"
import script from "./content_edit_Case.vue?vue&type=script&lang=js"
export * from "./content_edit_Case.vue?vue&type=script&lang=js"
import style0 from "./content_edit_Case.vue?vue&type=style&index=0&id=943abbba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "943abbba",
  null
  
)

export default component.exports